export default __webpack_public_path__ + "a97a2f3960e0128041128070ff1254ec.png";